import { render, staticRenderFns } from "./ModalReportDetailSicbo.vue?vue&type=template&id=4f23320a&"
import script from "./ModalReportDetailSicbo.vue?vue&type=script&lang=js&"
export * from "./ModalReportDetailSicbo.vue?vue&type=script&lang=js&"
import style0 from "./ModalReportDetailSicbo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports